import { useCallback, useState } from 'react'
import { Button } from 'blaze-ui/Button/Button'
import { REACT_APP_READER_URL } from 'env'
import { useQueryParams } from 'hooks/useQueryParams'
import { navigateToExternalUrl } from 'utils/location'
import { isWebview } from 'utils/browserUtils'
import Styles from './GoogleOAuthButton.module.scss'
import { IS_VM_REGISTRATION_KEY } from '../constants'
import { Google } from 'blaze-ui/icons'

export const GoogleOAuthButton = ({
  workspaceInviteToken,
  checkNewUser = false,
}: {
  workspaceInviteToken: string
  checkNewUser?: boolean
}) => {
  const [isProcessing, setIsProcessing] = useState(false)
  const { domain, redirect_to, promotion_code, campaigns } = useQueryParams()

  const loginOrSignup = useCallback(async () => {
    localStorage.setItem(IS_VM_REGISTRATION_KEY, 'true')
    setIsProcessing(true)
    const state = {
      redirect_to,
      workspace_invite_token: workspaceInviteToken,
      domain,
      promotion_code,
      check_new_user: checkNewUser,
      campaigns,
    }

    const encodedState = btoa(JSON.stringify(state))
    const authUrl = `${REACT_APP_READER_URL}/omniauth/google_oauth2?state=${encodedState}`

    if (window.top && window.top !== window) {
      window.top.location.href = authUrl
      return
    }

    navigateToExternalUrl(authUrl)
  }, [domain, redirect_to, workspaceInviteToken, promotion_code, checkNewUser, campaigns])

  if (isWebview(window.navigator.userAgent)) return null

  return (
    <Button
      variant="secondary"
      size="xl"
      fullWidth
      frontIcon={Google}
      useChildClass
      onPress={loginOrSignup}
      isDisabled={isProcessing}
      data-heap-id="continue-with-google"
    >
      <div className={Styles.googleOAuthButton}>Continue with Google</div>
    </Button>
  )
}
